import { render, staticRenderFns } from "./tablaPerfil.vue?vue&type=template&id=6adbb9b4&scoped=true&"
import script from "./tablaPerfil.vue?vue&type=script&lang=js&"
export * from "./tablaPerfil.vue?vue&type=script&lang=js&"
import style0 from "./tablaPerfil.vue?vue&type=style&index=0&id=6adbb9b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adbb9b4",
  null
  
)

export default component.exports